import { useCallback, useLayoutEffect } from "react";

export function useDeviceNavigation({
  isFullScreen,
  onClose,
  onBackButton,
  onNavigation,
}: {
  isFullScreen: boolean;
  onClose: () => void;
  onBackButton: () => void;
  onNavigation: (delta: number) => void;
}) {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
      if (event.key === "ArrowRight") {
        onNavigation(1);
      }
      if (event.key === "ArrowLeft") {
        onNavigation(-1);
      }
    },
    [onClose, onNavigation],
  );
  const handleBackButton = useCallback(() => {
    onBackButton();
  }, [onBackButton]);
  useLayoutEffect(() => {
    // Get original body overflow style
    const originalStyle = window.getComputedStyle(document.body).overflow;

    // Prevent scrolling on mount
    document.body.style.overflow = isFullScreen ? "hidden" : originalStyle;
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("popstate", handleBackButton);

    // Re-enable scrolling on unmount
    return () => {
      document.body.style.overflow = originalStyle;
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [isFullScreen, handleKeyDown, handleBackButton]);
}
